import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiConfiguration } from '../api/api-configuration';
import { MissionResponseDto } from '../api/models/mission-response-dto';

@Injectable({ providedIn: 'root' })
export class MissionService {
  private http = inject(HttpClient);
  private config = inject(ApiConfiguration);

  getActiveMission(): Observable<MissionResponseDto | null> {
    return this.http.get<MissionResponseDto>(`${this.config.rootUrl}/missions/active-mine`).pipe(
      catchError(err => {
        if (err.status === 204 || err.status === 404) return of(null);
        return of(null);
      })
    );
  }
}
